function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { Image, Link } from "@labs/schema";
import React from "react";
import { FadeUp } from "../Molecules/FadeUp";
function VacancyCard(param) {
    var text = param.text, url = param.url;
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-h-7 aspect-w-5 mb-12 md:mb-24"
    }, /*#__PURE__*/ React.createElement(Link, {
        href: url,
        className: "block h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex h-full items-center justify-center bg-purple text-white text-center relative py-24 md:py-10 px-8 md:px-5 lg:px-8 xl:px-12"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "m-0 font-normal text-lg md:text-base lg:text-xl sm:leading-2xl lg:leading-xl"
    }, text)))));
}
function TeamTeaser(param) {
    var image = param.image, jobTitle = param.jobTitle, name = param.name, _param_priority = param.priority, priority = _param_priority === void 0 ? false : _param_priority;
    return /*#__PURE__*/ React.createElement(FadeUp, {
        yGap: 50
    }, /*#__PURE__*/ React.createElement("div", {
        className: "group relative block overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-h-7 aspect-w-5 overflow-hidden"
    }, /*#__PURE__*/ React.createElement(Image, _extends({
        alt: name
    }, image, {
        className: "!absolute !block w-full max-w-full object-cover pb-0",
        priority: priority
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "bg-yellow text-center absolute bottom-0 left-0 translate-y-full duration-[400ms] group-hover:translate-y-0 w-full transition-all opacity-0 transition-all group-hover:opacity-100"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "py-7 lg:py-10 xl:py-12 px-5"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "my-0 lg:mb-1.5 text-lg md:text-base lg:text-lg"
    }, name), jobTitle ? /*#__PURE__*/ React.createElement("p", {
        className: "text-turquoise-500 font-normal block w-full m-0 text-sm"
    }, jobTitle) : null))));
}
export function Team(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "container-page mb-16"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "container-content md:mt-14 lg:mt-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "space-y-12 container-content-wrapper"
    }, /*#__PURE__*/ React.createElement("ul", {
        role: "list",
        className: "space-y-10 md:space-y-12 sm:grid sm:grid-cols-2 sm:gap-6 lg:gap-8 sm:space-y-0 md:grid-cols-3"
    }, props.teamMembers.map(function(item, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: item.name + index,
            className: "!mt-0 !mb-6 sm:!mb-0"
        }, /*#__PURE__*/ React.createElement(TeamTeaser, _extends({}, item, {
            priority: index < 3
        })));
    }), props.contact && props.contact.label && props.contact.link ? /*#__PURE__*/ React.createElement("li", {
        className: "!mt-0 !mb-6 sm:!mb-0"
    }, /*#__PURE__*/ React.createElement(VacancyCard, {
        text: props.contact.label,
        url: props.contact.link
    })) : null))));
}
